import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-down', 'IconArrowDown', [
  ['path', { d: 'M12 5l0 14', key: 'svg-0' }],
  ['path', { d: 'M18 13l-6 6', key: 'svg-1' }],
  ['path', { d: 'M6 13l6 6', key: 'svg-2' }],
]);
